import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import AmericanTableIcon from 'components/AmericanTableIcon'
import FrenchTableIcon from 'components/FrenchTableIcon'
import PoolTableIcon from 'components/PoolTableIcon'
import SnookerTableIcon from 'components/SnookerTableIcon'
import ChineseTableIcon from 'components/ChineseTableIcon'
import { tableTypesMatcher } from 'utils/labelMatcher'
const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    spacing: 8
  },
  iconEnabled: {
    marginRight: theme.spacing.unit,
    color: theme.palette.primary.main + '!important'
  },
  iconDisabled: {
    marginRight: theme.spacing.unit,
    color: theme.palette.action.disabled + '!important'
  }
})

export default withStyles(styles)(
  class BillardConfigurationComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      updateTableTypeSettings: PropTypes.func.isRequired,
      tableTypes: PropTypes.object
    }

    static defaultProps = {
      tableTypes: {
        american: true,
        carom: false,
        chinese: false,
        snooker: false,
        pool: false
      }
    }
    handleChange = name => event => {
      // this.props.handleChange({...this.state, [name] : event.target.checked})
      // this.setState({[name] : event.target.checked})
      this.props.updateTableTypeSettings(name, event.target.checked)
    }

    render() {
      const { classes, tableTypes } = this.props
      const { american, carom, chinese, snooker, pool } = tableTypes
      return (
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="stretch"
          alignContent="stretch"
          spacing={24}>
          <Grid item xs={10} sm={8} md={12}>
            <Typography variant="subheading">
              Quels types de tables possédez vous dans votre salle ?{' '}
            </Typography>
          </Grid>
          <Grid item xs={10} sm={8} md={12}>
            <Divider light />
          </Grid>
          <Grid item xs={10} sm={8} md={6}>
            <FormControlLabel
              className={classes.formControl}
              control={
                <Switch
                  checked={american || false}
                  onChange={this.handleChange('american')}
                  value="american"
                  color="primary"
                />
              }
              label={
                <div className={classes.labelContainer}>
                  <AmericanTableIcon
                    className={
                      american ? classes.iconEnabled : classes.iconDisabled
                    }
                  />
                  {tableTypesMatcher('american')}
                </div>
              }
            />
          </Grid>
          <Grid item xs={10} sm={8} md={6}>
            <FormControlLabel
              className={classes.formControl}
              control={
                <Switch
                  checked={carom || false}
                  onChange={this.handleChange('carom')}
                  value="carom"
                  color="primary"
                />
              }
              label={
                <div className={classes.labelContainer}>
                  <FrenchTableIcon
                    className={
                      carom ? classes.iconEnabled : classes.iconDisabled
                    }
                  />
                  {tableTypesMatcher('carom')}
                </div>
              }
            />
          </Grid>
          <Grid item xs={10} sm={8} md={6}>
            <FormControlLabel
              className={classes.formControl}
              control={
                <Switch
                  checked={chinese || false}
                  onChange={this.handleChange('chinese')}
                  value="chinese"
                  color="primary"
                />
              }
              label={
                <div className={classes.labelContainer}>
                  <ChineseTableIcon
                    className={
                      chinese ? classes.iconEnabled : classes.iconDisabled
                    }
                  />
                  {tableTypesMatcher('chinese')}
                </div>
              }
            />
          </Grid>
          <Grid item xs={10} sm={8} md={6}>
            <FormControlLabel
              className={classes.formControl}
              control={
                <Switch
                  checked={pool || false}
                  onChange={this.handleChange('pool')}
                  value="pool"
                  color="primary"
                />
              }
              label={
                <div className={classes.labelContainer}>
                  <PoolTableIcon
                    className={
                      pool ? classes.iconEnabled : classes.iconDisabled
                    }
                  />
                  {tableTypesMatcher('pool')}
                </div>
              }
            />
          </Grid>
          <Grid item xs={10} sm={8} md={6}>
            <FormControlLabel
              className={classes.formControl}
              control={
                <Switch
                  checked={snooker || false}
                  onChange={this.handleChange('snooker')}
                  value="snooker"
                  color="primary"
                />
              }
              label={
                <div className={classes.labelContainer}>
                  <SnookerTableIcon
                    className={
                      snooker ? classes.iconEnabled : classes.iconDisabled
                    }
                  />
                  {tableTypesMatcher('snooker')}
                </div>
              }
            />
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/DashpoolConfiguration/BillardConfigurationComponent.js